import React from 'react';

const Footer = ({ config }) => {
  if (!config) return null;

  const {
    textColor = '#303235',
    text = 'Powered by',
    company = 'GreenLight Credentials',
    companyLink = 'https://glcredentials.com'
  } = config;

  return (
    <div className="w-full py-4 text-center border-t border-gray-200 bg-white">
      <p style={{ color: textColor }} className="text-sm">
        {text}{' '}
        <a
          href={companyLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: textColor }}
          className="font-semibold hover:underline"
        >
          {company}
        </a>
      </p>
    </div>
  );
};

export default Footer;
